var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckmarkDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13321 9.20839L6.92488 13.9917L6.04154 14.8751C5.96331 14.9539 5.85681 14.9983 5.74571 14.9983C5.63461 14.9983 5.52811 14.9539 5.44988 14.8751L0.958211 10.3834C0.87933 10.3052 0.834961 10.1987 0.834961 10.0876C0.834961 9.97646 0.87933 9.86996 0.958211 9.79172L1.54154 9.20839C1.61978 9.12951 1.72628 9.08514 1.83738 9.08514C1.94848 9.08514 2.05497 9.12951 2.13321 9.20839ZM19.0415 5.45006L18.4582 4.85839C18.2934 4.69857 18.0314 4.69857 17.8665 4.85839L9.90821 12.8167L9.00821 11.9167L14.8415 6.08339C14.9204 6.00515 14.9648 5.89865 14.9648 5.78756C14.9648 5.67646 14.9204 5.56996 14.8415 5.49172L14.2582 4.90006C14.0934 4.74024 13.8314 4.74024 13.6665 4.90006L7.83321 10.7751L6.29988 9.20839C6.22164 9.12951 6.11514 9.08514 6.00404 9.08514C5.89294 9.08514 5.78645 9.12951 5.70821 9.20839L5.12488 9.79172C5.046 9.86996 5.00163 9.97646 5.00163 10.0876C5.00163 10.1987 5.046 10.3052 5.12488 10.3834L9.61654 14.8751C9.69478 14.9539 9.80128 14.9983 9.91238 14.9983C10.0235 14.9983 10.13 14.9539 10.2082 14.8751L19.0415 6.04172C19.1204 5.96349 19.1648 5.85699 19.1648 5.74589C19.1648 5.63479 19.1204 5.52829 19.0415 5.45006Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkDouble);
export default __webpack_public_path__ + "static/media/icon-checkmark-double.d64a9117.svg";
export { ForwardRef as ReactComponent };